import {
	reportConstants
}from "./constants"

const initialState =
{
	isSending     : false,
	paged         : {},
	list          : [],
	isFileSending : false,
	indexes       : []
}

export default function (state = initialState, action){
	switch (action.type){
		case reportConstants.GetReport1Chart1Paged.REQUEST:
		case reportConstants.GetReport1Chart2Paged.REQUEST:
		case reportConstants.GetReport2Chart1Paged.REQUEST:
		case reportConstants.GetReport2Chart2Paged.REQUEST:
		case reportConstants.GetReport2Chart3Paged.REQUEST:
		case reportConstants.GetReport3Paged.REQUEST:
		case reportConstants.GetReport6Paged.REQUEST:
		case reportConstants.GetReport7.REQUEST:
			return {
				...state,
				isSending: true
			}

		case (reportConstants.GetReport1File.REQUEST): {
			return {
				...state,
				isFileSending: true
			}
		}
		case (reportConstants.GetReport1File.SUCCESS):
		case (reportConstants.GetReport1File.FAILURE): {
			return {
				...state,
				isFileSending: false
			}
		}
		case reportConstants.GetReport1Chart1Paged.FAILURE:
		case reportConstants.GetReport1Chart2Paged.FAILURE:
		case reportConstants.GetReport2Chart1Paged.FAILURE:
		case reportConstants.GetReport2Chart2Paged.FAILURE:
		case reportConstants.GetReport2Chart3Paged.FAILURE:
		case reportConstants.GetReport3Paged.FAILURE:
		case reportConstants.GetReport6Paged.FAILURE:
		case reportConstants.GetReport7.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case reportConstants.GetReport1Chart1Paged.SUCCESS:
		case reportConstants.GetReport1Chart2Paged.SUCCESS:
		case reportConstants.GetReport2Chart1Paged.SUCCESS:
		case reportConstants.GetReport2Chart2Paged.SUCCESS:
		case reportConstants.GetReport2Chart3Paged.SUCCESS:
		case reportConstants.GetReport6Paged.SUCCESS:
		case reportConstants.GetReport3Paged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reportConstants.GetReport7.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reportConstants.GetIndexes.SUCCESS:
			return {
				...state,
				indexes: action.payload.result
			}
		case reportConstants.CLEAR:
			return {
				...state,
				isSending : false,
				paged     : {}
			}
		default:
			return state
	}
}